import React, { useEffect, useState } from "react";

import homePagePayload from "../../config/homePayload";
import homePageAPI from "../../api/homePageApi";

import Banner from "./Banner";
import CouponFlash from "./CouponFlash";
import CategoryCard from "../categories/Card";
import Testimonials from "../testimonials/Card";
import Blog from "../blogs/Card";
import Product from "../products/Card";
import { motion, AnimatePresence } from "framer-motion";
import { MoveRight, Calendar } from "lucide-react";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "./Shared/CustomSwiper";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import MiddleSection from "./MiddleSection";
import CtaBanner from "./CtaBanner";

function Home() {
  const CACHE_TIME = 180000; // 3 minutes

  const [banners, setBanners] = useState([]);
  const [middleBanners, setMiddleBanners] = useState([]);
  const [topBanners, setTopBanners] = useState([]);

  const [coupons, setCoupons] = useState([]);
  const [categories, setCategories] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [products, setProducts] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [activeId, setActiveId] = useState(testimonials?.[0]?.id || null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Set the active ID based on the card currently in center
            setActiveId(Number(entry.target.getAttribute("data-id")));
          }
        });
      },
      {
        root: null,
        rootMargin: "-45% 0px -45% 0px", // Trigger only when element is in the exact MIDDLE 10% of screen
        threshold: 0,
      },
    );

    const cards = document.querySelectorAll(".editorial-card");
    cards.forEach((card) => observer.observe(card));

    return () => cards.forEach((card) => observer.unobserve(card));
  }, []);

  useEffect(() => {
    fetchHomePageDetails();
  }, []);

  const fetchHomePageDetails = async () => {
    const res = await homePageAPI.homePage(homePagePayload);

    if (res.code === 200) {
      const result = res.data;

      const allBanners = result?.banners || [];

      setTopBanners(allBanners.filter((b) => b.position === "top"));
      setMiddleBanners(allBanners.filter((b) => b.position === "middle"));
      setCoupons(result?.coupons);
      setCategories(result?.categories);
      setTestimonials(result?.testimonials);
      setBlogs(result?.blogs);
      setProducts(result?.products);
      setTestimonials(result?.testimonials);
    }
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [activeVariant, setActiveVariant] = useState(1);

  return (
    <>
      <section className="triple-hero">
        {/* 🔥 DESKTOP VIEW */}
        <div className="desktop-view">
          {products.slice(0, 3).map((product, index) => (
            <div className="hero-card" key={index}>
              <img
                src="../../../images/topbanner.png"
                alt=""
                className="hero-bg"
              />
              <div className="hero-overlay"></div>

              <div className="hero-inner">
                <div className="hero-text">
                  <h2>{product.title}</h2>
                  <p> {product.shortDescription}</p>
                  <Link to="/shop" className="custom-link-detail">
                    <button>Buy Now </button>
                  </Link>
                </div>

                <div className="hero-product">
                  <img src={product.thumbnail} alt="product" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 🔥 MOBILE VIEW (SWIPER) */}
        <div className="mobile-view">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={10}
            slidesPerView={1}
            loop={true}
            navigation={true}
            pagination={{ clickable: true }}
          >
            {products.slice(0, 3).map((product, index) => (
              <SwiperSlide key={index}>
                <div className="hero-card">
                  {/* <img src="../../../images/topbanner.png   alt="bg-image" className="hero-bg" /> */}
                  <img
                    src="../../../images/topbanner.png"
                    alt=""
                    className="hero-bg"
                  />
                  <div className="hero-overlay"></div>

                  <div className="hero-inner">
                    <div className="hero-text">
                      <h2>{product.title}</h2>
                      <p>{product.shortDescription}</p>
                      {/* <button>{item.btn}</button> */}
                      <Link to={`/product/${product.slug}`}>
                        <button>Buy Now </button>
                      </Link>
                    </div>

                    <div className="hero-product">
                      <img src={product.thumbnail} alt="product" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* coupon listing */}
      {coupons && coupons.length > 0 && (
        <div className="marquee-sale marquee-border font-main">
          <div className="marquee-wrapper">
            <div className="initial-child-container">
              {coupons.map((coupon, index) => (
                <React.Fragment key={index}>
                  <CouponFlash item={coupon} />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* {categories && categories.length > 0 && (
        <section className="shutter-section">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-6 text-start">
                <h2 className="shutter-heading">
                  <span>Featured Categories</span>
                </h2>
              </div>
              <div className="col-lg-6 text-end">
                <Link
                       to="categories"
                       className="image img-style d-block"
                     >
                  <h4 className="shutter-heading-view">
                    <span>View All</span>
                  </h4>
                   </Link>
              </div>           
          </div>

          <div className="row g-4">
            <div className="col-lg-6">
              {categories[3] && (
                <div className="shutter-card h-100">
                  <Link
                    to={`/categories/${categories[3]?.slug || categories[3]?.slugPath
                      }`}
                    className="image img-style d-block"
                  >
                    <div className="img-layer">
                      <img
                        src={categories[3].image}
                        alt={categories[3].name}
                      />
                    </div>

                    <div className="shutter-panel panel-left"></div>
                    <div className="shutter-panel panel-right"></div>

                    <div className="content-layer">
                      <div className="text-box">
                        <span className="cat-subtitle">
                          {categories[3].subtitle}
                        </span>
                        <h3>{categories[3].name}</h3>
                        <div className="btn-wrapper">
                          <Link to="/shop" className="shutter-btn">
                            View 
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="border-trace"></div>
                  </Link>
                </div>
              )}
            </div>
            <div className="col-lg-6">
              <div className="row g-4">
                {categories
                  .filter((_, index) => index !== 3)
                  .map((category, index) => (
                    <div key={index} className="col-6">
                      <CategoryCard item={category} />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        </section >
      )
} */}

      {/* {categories && categories.length > 0 && (

       <section className="shutter-section">
      <div className="container">
        <div className="row align-items-end">
              <div className="col-lg-6 text-start">
                <h2 className="shutter-heading">
                  <span>Featured Categories</span>
                </h2>
              </div>
              <div className="col-lg-6 text-end">
                <Link
                       to="categories"
                       className="image img-style d-block"
                     >
                  <h4 className="shutter-heading-view">
                    <span>View All</span>
                  </h4>
                   </Link>
              </div>           
          </div>
        <div className="row g-4">
          {categories.map((category, index) => (
            <div key={index} className="col-lg-6 col-md-6">              
               <CategoryCard item={category} />
            </div>
          ))}
        </div>
      </div>
    </section>
     )} */}

      <div className="container  mt-5">
        <div className="row align-items-end">
          <div className="col-lg-6 text-start">
            <h2 className="shutter-heading">
              <span>Featured Categories</span>
            </h2>
          </div>
          <div className="col-lg-6 text-end">
            <Link to="categories" className="image img-style d-block">
              <h4 className="shutter-heading-view">
                <span>View All</span>
              </h4>
            </Link>
          </div>
        </div>
      </div>

      <div className="container ">
        <div className="row  g-3">
          <div className="col-lg-6">
            <div className="shutter-section">
              <div className="shutter-card">
                <Link to="/manufacturing" className="image img-style d-block">
                  <div className="img-layer">
                    <img
                      src="../../images/prdctbg.png"
                      alt="images"
                      className="custom-catg-img-sec"
                    />
                    {/* {item?.image && (
               <img src={item?.image} alt="categories" className="lazyload" />
             )} */}
                  </div>
                  <div className="shutter-panel panel-left"></div>
                  <div className="shutter-panel panel-right"></div>
                  <div className="content-layer">
                    <div className="text-box">
                      <h3> Manufacturing</h3>
                      <Link to="/manufacturing" className="shutter-btn">
                        <p>Top Trend Ayurveda A Group of Sun Rise Pharma </p>
                      </Link>
                      <p className="custom-view-catg">
                        View <ArrowRight />
                      </p>
                      {/* <p>{item.description}</p>      */}
                      <div className="btn-wrapper">
                        {/* <Link to="/manufacturing" className="shutter-btn">
                
                  <p>Top Trend Ayurveda A Group of Sun Rise Pharma </p> 
                 </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="border-trace"></div>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="shutter-section">
              <div className="shutter-card">
                <Link to="shop" className="image img-style d-block">
                  <div className="img-layer">
                    <img src="../../images/prdctbg.png" alt="images" />
                    {/* {item?.image && (
               <img src={item?.image} alt="categories" className="lazyload" />
             )} */}
                  </div>
                  <div className="shutter-panel panel-left"></div>
                  <div className="shutter-panel panel-right"></div>
                  <div className="content-layer">
                    <div className="text-box">
                      {/* <h3>{item.name}</h3>   */}
                      {/* <p>{item.description}</p>      */}
                      <h3>Product & Shop All</h3>
                      <p className="custom-view-catg">
                        View <ArrowRight />
                      </p>
                      <div className="btn-wrapper">
                        <Link to="shop" className="shutter-btn">
                          {/* Product & Shop All */}
                          <h3>Product & Shop All</h3>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="border-trace"></div>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="shutter-section">
              <div className="shutter-card">
                <Link to="categories" className="image img-style d-block">
                  <div className="img-layer">
                    <img src="../../images/prdctbg.png" alt="images" />
                  </div>
                  <div className="shutter-panel panel-left"></div>
                  <div className="shutter-panel panel-right"></div>
                  <div className="content-layer">
                    <div className="text-box">
                      <h3> Disease</h3>
                      <Link to="/manufacturing" className="shutter-btn">
                        Acidity, Sugar, BP(Heart), Joint Pain,Migrane
                      </Link>
                      <p className="custom-view-catg">
                        View <ArrowRight />
                      </p>
                      <div className="btn-wrapper"></div>
                    </div>
                  </div>

                  <div className="border-trace"></div>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="shutter-section">
              <div className="shutter-card">
                <Link to="/clinic" className="image img-style d-block">
                  <div className="img-layer">
                    <img src="../../images/prdctbg.png" alt="images" />
                    {/* {item?.image && (
               <img src={item?.image} alt="categories" className="lazyload" />
             )} */}
                  </div>
                  <div className="shutter-panel panel-left"></div>
                  <div className="shutter-panel panel-right"></div>
                  <div className="content-layer">
                    <div className="text-box">
                      <h3>Clinic of Doctor</h3>
                      {/* <p>{item.description}</p>      */}
                      <p className="custom-view-catg">
                        View <ArrowRight />
                      </p>
                      <div className="btn-wrapper">
                        <Link to="/clinic" className="shutter-btn">
                          <h3>Clinic of Doctor </h3>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="border-trace"></div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MiddleSection />
      {products && products.length > 0 && (
        <div className="compact-section">
          <div className="container ">
            <div className="">
              {/* <div className="">
                <h4>Our Products</h4>
                  <h2 className="compact-title">Essential <span>Care</span></h2>
              </div> */}
              <div className="col-lg-12 text-start">
                <h2 className="shutter-heading">
                  <span>Trending Products</span>
                </h2>
              </div>
              <div className="row  g-4 ">
                {products.map((product, index) => (
                  <div
                    className="col-lg-4 col-sm-6 col-xs-6 mb-3"
                    key={[product._id || index]}
                  >
                    <Product item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {middleBanners &&
        middleBanners.length > 0 &&
        middleBanners.map((banner, index) => (
          <CtaBanner key={index} banner={banner} />
        ))}

      {testimonials && testimonials.length > 0 && (
        <section className="editorial-section">
          <div className="container">
            {/* <div className="text-center mb-5">
              <h2 className="compact-title text-start">
                Customer <span>Reviews</span>
              </h2>
            </div> */}
            <div className="col-lg-12 text-start">
              <h2 className="shutter-heading">
                <span>Customer Reviews</span>
              </h2>
            </div>
            <div className="row">
              <div className="col-lg-5 d-none d-lg-block">
                <div className="sticky-frame">
                  <div className="visual-card">
                    <img
                      src="../../../images/banneside.png"
                      alt="Radiant Skin"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 offset-lg-1">
                {/* <div className="d-lg-none text-center mb-5">
                  <h2 className="mobile-title">Community Love</h2>
                  <p className="mobile-sub">Rated 4.9/5 by 2000+ Customers</p>
                </div> */}

                <div className="reviews-timeline">
                  {/* Vertical Line Connector */}
                  <div className="timeline-line"></div>

                  {testimonials.map((testimonial, index) => (
                    <div key={index}>
                      <div
                        key={testimonial.id}
                        data-id={testimonial.id}
                        className={`editorial-card ${activeId === testimonial.id ? "card-active" : ""}`}
                      >
                        {/* Timeline Dot */}
                        <div
                          className={`timeline-dot ${activeId === testimonial.id ? "dot-active" : ""}`}
                        ></div>
                        <Testimonials item={testimonial} />
                      </div>
                    </div>
                  ))}
                  <div
                    style={{ height: "20vh" }}
                    className="d-none d-lg-block"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {blogs && blogs.length > 0 && (
        <section className="blogbackground flat-spacing-2 pb-5">
          <div className="container">
            {/* <div className="flat-title wow fadeInUp">
              <h2 className="compact-title mb-4">
                Latest <span>Blogs</span>
              </h2>
            
            </div> */}
            <div className="col-lg-12 text-start">
              <h2 className="shutter-heading">
                <span> Latest Blogs</span>
              </h2>
            </div>

            <div className="row  g-3">
              {blogs.map((blog, index) => (
                <div key={index} className="col-md-4">
                  <Blog item={blog} />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
export default Home;
